import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";

const FloatingCartButton = () => {
  const cartItems = useSelector((state) => state.cart.items);
  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const navigate = useNavigate();

  if (totalItems === 0) return null; // Hide when cart is empty

  return (
    <button
      type="button"
      aria-label={`View cart, ${totalItems} items`}
      onClick={() => navigate("/cart")}
      className="fixed bottom-6 right-6 z-50 bg-purple-700 hover:bg-purple-800 text-white p-4 rounded-full shadow-xl transition-all duration-300 flex items-center justify-center group"
    >
      <FaShoppingCart className="text-2xl" />
      <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5 shadow">
        {totalItems}
      </span>

      {/* Hover label */}
      <span aria-hidden="true" className="pointer-events-none absolute right-14 bg-purple-800 text-white text-sm py-1 px-2 rounded-md opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity duration-300 whitespace-nowrap">
        View Cart
      </span>
    </button>
  );
};

export default FloatingCartButton;
